import React from "react";
import Typography from "@mui/material/Typography";

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardActionArea from "@mui/material/CardActionArea";
import CardActions from "@mui/material/CardActions";
import Box from "@mui/material/Box";

import LoadingButton from "@mui/lab/LoadingButton";
import AddIcon from "@mui/icons-material/Add";
import IconButton from "@mui/material/IconButton";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import { useTheme } from "@mui/material/styles";

import ScenarioSelector from "./../ScenarioSelector";

import { isMobile } from "react-device-detect";

const minCardWidth = 400;
const maxCardWidth = 400;
const cardHeight = 200;

const unselectedHelperTextString =
  "Select a forecast from the dropdown and click here to add and configure a forecast! Click the info icon to learn more about each option.";

type AddScenarioCardProps = {
  currentScenario: string;
  currentDescription: string;
  setScenario: (newScenario: string) => void;
  scenarioOptions: string[];
  handleInfoClick: () => void;
  handleAdd: () => void;
  loading: boolean;
};

function AddScenarioCard(props: AddScenarioCardProps) {
  const theme = useTheme();
  const border = 1;
  const borderWidth = 2;
  const borderStyle = undefined;
  const borderColor = theme.palette.info.dark;
  const backgroundColor = undefined;
  const mainTextColor = theme.palette.text.primary;

  return (
    <Card
      sx={{
        maxWidth: isMobile ? "100%" : maxCardWidth,
        minWidth: isMobile ? "100%" : minCardWidth,
        minHeight: cardHeight,
        maxHeight: cardHeight,
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        backgroundColor: backgroundColor,
        border: border,
        borderWidth: borderWidth,
        borderColor: borderColor,
        borderStyle: borderStyle,
        zIndex: 0,
        position: "relative",
      }}
    >
      <Box
        sx={{
          flexGrow: 1,
          minHeight: 0,
          width: "100%",
          pt: 2,
          px: 2,
          backgroundColor: backgroundColor,
          overflowY: "auto",
          justifyContent: "",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <ScenarioSelector
          currentScenario={props.currentScenario}
          scenarioOptions={props.scenarioOptions}
          onChange={props.setScenario}
          color="info"
          helperText={props.currentScenario === "" ? unselectedHelperTextString : props.currentDescription}
        />
        {/* <Box sx={{ overflow: "auto" }}> 
          <Typography variant="subtitle2">
            {props.currentScenario === "" ? unselectedHelperTextString : props.currentDescription}
          </Typography>
        </Box>*/}
      </Box>
      {/* <CardActionArea
        disabled={props.currentScenario === ""}
        onClick={props.handleAdd}
        sx={{
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
          overflow: "hidden",
          justifyContent: "flex-start",
          alignItems: "flex-start",
        }}
      >
        <CardContent sx={{ width: "100%", flexGrow: 1, overflowY: "auto", paddingTop: 1 }}>
          <Typography variant="body2" color={mainTextColor}>
            {props.currentScenario === ""
              ? "Select a forecast from the dropdown and click here to add and configure a forecast!"
              : props.currentDescription}
          </Typography>
        </CardContent>
      </CardActionArea> 
      TODO: is this or helper text better?
      */}
      <CardActions sx={{ justifyContent: "center", flexGrow: 0, alignItems: "center", paddingTop: 0 }}>
        <LoadingButton
          onClick={() => {
            if (props.currentScenario === "") {
              props.handleInfoClick();
            } else {
              props.handleAdd();
            }
          }}
          color="info"
          loading={props.loading}
          variant="contained"
          startIcon={props.currentScenario === "" ? <InfoOutlinedIcon /> : <AddIcon />}
          sx={{ flexGrow: 1, whiteSpace: "nowrap" }}
        >
          {props.currentScenario === "" ? "Learn About Forecast Options" : "Add New Forecast"}
        </LoadingButton>
        {props.currentScenario === "" ? null : (
          <IconButton onClick={props.handleInfoClick} color="info">
            {<InfoOutlinedIcon />}
          </IconButton>
        )}
      </CardActions>
    </Card>
  );
}

export default AddScenarioCard;
